import { useState, useEffect, useCallback } from 'react'
import { useContract } from './useContract.ts'
import { useWallet } from './useWallet.ts'

interface UseAdminReturn {
  isOwner: boolean
  loading: boolean
}

export function useAdmin(): UseAdminReturn {
  const contract = useContract()
  const { address, isConnected } = useWallet()
  const [isOwner, setIsOwner] = useState(false)
  const [loading, setLoading] = useState(true)

  const checkOwner = useCallback(async () => {
    if (!address || !isConnected) {
      setIsOwner(false)
      setLoading(false)
      return
    }
    try {
      const owner = await contract.getOwner()
      setIsOwner(owner.toLowerCase() === address.toLowerCase())
    } catch {
      setIsOwner(false)
    } finally {
      setLoading(false)
    }
  }, [address, isConnected, contract])

  useEffect(() => {
    checkOwner()
  }, [checkOwner])

  return { isOwner, loading }
}
